/* @flow */
import * as React from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";

import Gettext from "../../common/Gettext";
import Money from "../../Money";

import type { DepositBonusInserted as Bonus } from "../../../redux/CommonTypes";

import Modal from "../Modal";
import coinBig from "./images/big-coin.png";
import coinOver from "./images/over-coin.png";
import coinUnder from "./images/under-coin.png";

const Wrapper = styled.div`
  padding: 3.5em 7em 6em;

  @media (max-width: 959px) {
    padding: 1em 7em 1.75em;
  }
`;

const Heading = styled.h3`
  width: 100%;
  padding-bottom: 0.5em;
  padding-top: 0.833em;
  font-weight: 300;
  font-size: 3em;
  text-transform: uppercase;
  color: ${({theme}) => theme.foreground};
`;

const SubHeading = styled.div`
  max-width: 22.222em;
  margin: 0 auto;
  padding-bottom: 0.833em;
  font-weight: 500;
  font-size: 1.8em;
  color: #717171;
`;

const InfoText = styled.div`
  direction: ${props => props.theme.direction};
  max-width: 11.111em;
  margin: 0 auto;
  font-weight: 600;
  font-size: 3.6em;
  line-height: 1;
  color: ${({theme}) => theme.foreground};
`;

const MoneyContainer = styled.div`
  font-size: 5em;
  line-height: 1;
`;

const Value = styled(Money.Value)`
  font-weight: 600;
  color: #3B9478;
  font-size: 96px;
`;

const Currency = styled(Money.Symbol)`
  font-weight: 400;
  font-size: 0.49em;
  color: #717171;
`;

const Link = styled.div`
  display: inline-block;
  margin-top: 2.222em;
  font-weight: 500;
  font-size: 1.8em;
  text-decoration: none;
  color: #3498db;

  :hover {
    cursor: pointer;
  }
`;

const Coin = styled.img`position: absolute;`;

const CoinBig = styled(Coin)`
  width: 15.4em;
  height: auto;
  left: -5.2em;
  top: -5em;

  @media (max-width: 959px) {
    width: 16em;
  }
  @media (max-width: 959px) and (min-width: 480px) {
    top: -3.5em;
  }
`;

const CoinOver = styled(Coin)`
  width: 7.3em;
  height: auto;
  bottom: -2.7em;
  right: -3.2em;
`;

const CoinUnder = styled(Coin)`
  width: 10.6em;
  height: auto;
  bottom: 3.1em;
  right: -5.3em;
  z-index: -1;
`;

const domain =
  process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
    ? "IronTrade"
    : "SiamOption";

type Props = Bonus & {
  location: Object,
  history: Object,
  onDismiss: () => void
};

class ReferralBonus extends React.Component<Props, {}> {
  handleRedirect = () => {
    this.props.onDismiss();
    if (this.props.location.match !== "profile") {
      this.props.history.push("/profile");
    }
  };

  render() {
    return (
      <Modal onDismiss={this.props.onDismiss}>
        <Wrapper>
          <Heading>
            <Gettext>referral bonus</Gettext>
          </Heading>
          <SubHeading>
            <Gettext>Your friend</Gettext>{" "}
            <Gettext>has deposited necessary sum</Gettext>
          </SubHeading>
          <InfoText>
            <Gettext>You received a bonus</Gettext>:
          </InfoText>
          <MoneyContainer>
            <Money Value={Value} Symbol={Currency}>{this.props.amount}</Money>
          </MoneyContainer>
          <Link onClick={this.handleRedirect}>
            <Gettext>Invite more friends to {domain}</Gettext>
          </Link>

          <CoinBig src={coinBig} alt={coinBig} />
          <CoinOver src={coinOver} alt={coinOver} />
          <CoinUnder src={coinUnder} alt={coinUnder} />
        </Wrapper>
      </Modal>
    );
  }
}

export default withRouter(ReferralBonus);



// WEBPACK FOOTER //
// ./src/components/TradeModals/ReferralBonus/ReferralBonus.js